import { store } from '../../store'
import { http } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  getBranches ({commit, dispatch}, payload) {
    let url = 'api/branches-company/' + store.state.userLogged.company[0].id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetBranches', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getUsers ({commit, dispatch}, payload) {
    let url = `api/user/by-company/${store.state.userLogged.company[0].id}?page=1&perPage=1000`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetUsers', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  endWizard ({commit, dispatch}, payload) {
    let url = 'api/endWizard/' + store.state.userLogged.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.put(url, {}, options)
      .then(
        response => {
          commit('onWizard', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  onGetBranches (state, payload) {
    let branches = payload.response.data.data.branch
    payload.event.context.branches = branches
    payload.event.context.branchesByCompany.branch = branches
  },
  onGetUsers (state, payload) {
    let users = payload.response.data.data
    users.forEach(element => {
      element.email_original = element.email
      element.company_original = Object.assign({}, element.company)
      element.area_original = Object.assign({}, element.area)
      let temp = element.application[0]
      element.application = null
      element.application = temp
    })
    payload.event.context.users = users
  },
  onWizard (state, payload) {
    payload.event.context.dialog = false
    store.dispatch('userLogged', {event: {context: this}})
  },
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error, 'error')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/wizard.js